import React from 'react';
export function WordmarkOptions3() {
  return <div className="min-h-screen bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-1059">
      <div className="max-w-7xl mx-auto" data-id="element-1060">
        <div className="text-center mb-16" data-id="element-1061">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-1062">
            Creative Letterforms
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1063">
            12 wordmark variations with modified letterforms — merged strokes,
            removed crossbars, ligatures, and stylistic cuts. Based on your
            favorites #1, #3, and #6.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1064">
          {/* ===== BASED ON #1 (Bold Uppercase + Gradient AI) ===== */}

          {/* 1. Open A — crossbar removed from the A in MARK */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1065">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1066">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1067">
                1. Open A
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1068">
                Style #1 · Crossbar removed from A
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1069">
              <div className="flex items-baseline" data-id="element-1070">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1071">
                  SWEDENM
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter relative" data-id="element-1072">
                  A
                  <span className="absolute top-[52%] left-[12%] w-[76%] h-[4px] bg-white" data-id="element-1073"></span>
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1074">
                  RK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-1 relative" data-id="element-1075">
                  A
                  <span className="absolute top-[52%] left-[12%] w-[76%] h-[4px] bg-white" data-id="element-1076"></span>
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500" data-id="element-1077">
                  I
                </span>
                <div className="w-2 h-2 rounded-full bg-emerald-500 ml-1 mb-1" data-id="element-1078"></div>
              </div>
            </div>
          </div>

          {/* 2. Merged AI — A's right stroke becomes I */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1079">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1080">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1081">
                2. Merged AI
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1082">
                Style #1 · A+I share a stroke
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1083">
              <div className="flex items-end gap-2" data-id="element-1084">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1085">
                  SWEDENMARK
                </span>
                <svg viewBox="0 0 44 36" className="h-7 w-auto mb-1" fill="none" data-id="element-1086">
                  <defs data-id="element-1087">
                    <linearGradient id="grad1" x1="0" y1="0" x2="44" y2="0" gradientUnits="userSpaceOnUse" data-id="element-1088">
                      <stop offset="0%" stopColor="#2563eb" data-id="element-1089" />
                      <stop offset="100%" stopColor="#10b981" data-id="element-1090" />
                    </linearGradient>
                  </defs>
                  <path d="M2 34L16 2L30 34" stroke="url(#grad1)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" data-id="element-1091" />
                  <path d="M8 24H24" stroke="url(#grad1)" strokeWidth="3.5" strokeLinecap="round" data-id="element-1092" />
                  <line x1="30" y1="2" x2="30" y2="34" stroke="url(#grad1)" strokeWidth="4" strokeLinecap="round" data-id="element-1093" />
                  <line x1="24" y1="2" x2="36" y2="2" stroke="url(#grad1)" strokeWidth="3" strokeLinecap="round" data-id="element-1094" />
                  <line x1="24" y1="34" x2="36" y2="34" stroke="url(#grad1)" strokeWidth="3" strokeLinecap="round" data-id="element-1095" />
                </svg>
                <div className="w-2 h-2 rounded-full bg-emerald-500 mb-2" data-id="element-1096"></div>
              </div>
            </div>
          </div>

          {/* 3. Split E — the E is cut horizontally, top half offset */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1097">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1098">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1099">
                3. Split E
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1100">
                Style #1 · E letters halved
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1101">
              <div className="flex items-baseline" data-id="element-1102">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1103">
                  SW
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter" style={{
                clipPath: 'polygon(0 0, 100% 0, 100% 45%, 0 45%)'
              }} data-id="element-1104">
                  E
                </span>
                <span className="text-3xl font-black text-slate-500 tracking-tighter" style={{
                marginLeft: '-0.6em',
                clipPath: 'polygon(0 55%, 100% 55%, 100% 100%, 0 100%)'
              }} data-id="element-1105">
                  E
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1106">
                  D
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter" style={{
                clipPath: 'polygon(0 0, 100% 0, 100% 45%, 0 45%)'
              }} data-id="element-1107">
                  E
                </span>
                <span className="text-3xl font-black text-slate-500 tracking-tighter" style={{
                marginLeft: '-0.6em',
                clipPath: 'polygon(0 55%, 100% 55%, 100% 100%, 0 100%)'
              }} data-id="element-1108">
                  E
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1109">
                  NMARK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-1" data-id="element-1110">
                  AI
                </span>
                <div className="w-2 h-2 rounded-full bg-emerald-500 ml-1 mb-1" data-id="element-1111"></div>
              </div>
            </div>
          </div>

          {/* 4. Faded W leg — one leg of the W is lighter */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1112">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1113">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1114">
                4. Faded W
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1115">
                Style #1 · W right half faded
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1116">
              <div className="flex items-baseline" data-id="element-1117">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1118">
                  S
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter" style={{
                clipPath: 'polygon(0 0, 55% 0, 55% 100%, 0 100%)'
              }} data-id="element-1119">
                  W
                </span>
                <span className="text-3xl font-black text-slate-300 tracking-tighter" style={{
                marginLeft: '-0.55em',
                clipPath: 'polygon(50% 0, 100% 0, 100% 100%, 50% 100%)'
              }} data-id="element-1120">
                  W
                </span>
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-1121">
                  EDENMARK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-1" data-id="element-1122">
                  AI
                </span>
                <div className="w-2 h-2 rounded-full bg-emerald-500 ml-1 mb-1" data-id="element-1123"></div>
              </div>
            </div>
          </div>

          {/* ===== BASED ON #3 (Lowercase Tech) ===== */}

          {/* 5. Merged nm — n flows into m */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1124">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1125">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1126">
                5. Merged nm
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1127">
                Style #3 · n+m share a stroke
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1128">
              <div className="flex items-baseline" data-id="element-1129">
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1130">
                  swede
                </span>
                <span className="text-3xl font-bold text-slate-800" style={{
                letterSpacing: '-0.12em'
              }} data-id="element-1131">
                  nm
                </span>
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1132">
                  ark
                </span>
                <span className="text-3xl font-light text-slate-400 ml-1" data-id="element-1133">
                  ai
                </span>
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 ml-1" data-id="element-1134"></div>
              </div>
            </div>
          </div>

          {/* 6. Crossbar-less e — both e's have middle bar removed */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1135">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1136">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1137">
                6. Open e
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1138">
                Style #3 · e crossbars removed
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1139">
              <div className="flex items-baseline" data-id="element-1140">
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1141">
                  sw
                </span>
                <span className="text-3xl font-bold text-slate-800 tracking-tight relative" data-id="element-1142">
                  e
                  <span className="absolute top-[48%] left-[15%] w-[70%] h-[3px] bg-white" data-id="element-1143"></span>
                </span>
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1144">
                  d
                </span>
                <span className="text-3xl font-bold text-slate-800 tracking-tight relative" data-id="element-1145">
                  e
                  <span className="absolute top-[48%] left-[15%] w-[70%] h-[3px] bg-white" data-id="element-1146"></span>
                </span>
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1147">
                  nmark
                </span>
                <span className="text-3xl font-light text-slate-400 ml-1" data-id="element-1148">
                  ai
                </span>
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 ml-1" data-id="element-1149"></div>
              </div>
            </div>
          </div>

          {/* 7. Connected ark — letters flow together */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1150">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1151">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1152">
                7. Flowing ark
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1153">
                Style #3 · ark tightly kerned
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1154">
              <div className="flex items-baseline" data-id="element-1155">
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1156">
                  swedenm
                </span>
                <span className="text-3xl font-bold text-slate-800" style={{
                letterSpacing: '-0.08em'
              }} data-id="element-1157">
                  ark
                </span>
                <span className="text-3xl font-light text-slate-400 ml-1" data-id="element-1158">
                  ai
                </span>
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 ml-1" data-id="element-1159"></div>
              </div>
            </div>
          </div>

          {/* 8. Half-cut d — bottom of d faded */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1160">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1161">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1162">
                8. Dissolving d
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1163">
                Style #3 · d stem fades out
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1164">
              <div className="flex items-baseline" data-id="element-1165">
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1166">
                  swe
                </span>
                <span className="text-3xl font-bold tracking-tight" style={{
                background: 'linear-gradient(to bottom, #1e293b 60%, transparent 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }} data-id="element-1167">
                  d
                </span>
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-1168">
                  enmark
                </span>
                <span className="text-3xl font-light text-slate-400 ml-1" data-id="element-1169">
                  ai
                </span>
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 ml-1" data-id="element-1170"></div>
              </div>
            </div>
          </div>

          {/* ===== BASED ON #6 (Superscript) ===== */}

          {/* 9. Open A + Superscript */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1171">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1172">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1173">
                9. Open A Superscript
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1174">
                Style #6 · A crossbar removed
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1175">
              <div className="flex items-start" data-id="element-1176">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-1177">
                  SWEDENM
                </span>
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight relative" data-id="element-1178">
                  A
                  <span className="absolute top-[52%] left-[12%] w-[76%] h-[4px] bg-white" data-id="element-1179"></span>
                </span>
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight" data-id="element-1180">
                  RK
                </span>
                <span className="text-sm font-black text-purple-600 ml-0.5 mt-1" data-id="element-1181">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 10. Split M — middle of M is cut */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1182">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1183">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1184">
                10. Split M
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1185">
                Style #6 · M center valley cut
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1186">
              <div className="flex items-start" data-id="element-1187">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-1188">
                  SWEDEN
                </span>
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight" style={{
                clipPath: 'polygon(0 0, 40% 0, 40% 100%, 0 100%)'
              }} data-id="element-1189">
                  M
                </span>
                <span className="text-3xl font-extrabold text-slate-400 tracking-tight" style={{
                marginLeft: '-0.62em',
                clipPath: 'polygon(40% 0, 60% 0, 60% 100%, 40% 100%)'
              }} data-id="element-1190">
                  M
                </span>
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight" style={{
                marginLeft: '-0.62em',
                clipPath: 'polygon(60% 0, 100% 0, 100% 100%, 60% 100%)'
              }} data-id="element-1191">
                  M
                </span>
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight" data-id="element-1192">
                  ARK
                </span>
                <span className="text-sm font-black text-purple-600 ml-0.5 mt-1" data-id="element-1193">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 11. Merged EN — E and N share vertical */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1194">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1195">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1196">
                11. Tight EN
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1197">
                Style #6 · E+N overlap
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1198">
              <div className="flex items-start" data-id="element-1199">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-1200">
                  SWED
                </span>
                <span className="text-3xl font-extrabold text-slate-900" style={{
                letterSpacing: '-0.1em'
              }} data-id="element-1201">
                  EN
                </span>
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-1202">
                  MARK
                </span>
                <span className="text-sm font-black text-purple-600 ml-0.5 mt-1" data-id="element-1203">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 12. Gradient fade K — K dissolves into AI */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-1204">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1205">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-1206">
                12. Dissolving K
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-1207">
                Style #6 · K fades into AI
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-1208">
              <div className="flex items-start" data-id="element-1209">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-1210">
                  SWEDENMAR
                </span>
                <span className="text-3xl font-extrabold tracking-tight" style={{
                background: 'linear-gradient(to right, #0f172a 20%, #9333ea 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }} data-id="element-1211">
                  K
                </span>
                <span className="text-sm font-black text-purple-600 mt-1" style={{
                marginLeft: '-2px'
              }} data-id="element-1212">
                  AI
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}